<template>
    <v-group
            :config="groupConfig"
            @dblclick="openEditPopup"
            @mouseover="hover(true)"
            @mouseout="hover(false)"
    >
        <v-arc :config="arcConfig"></v-arc>

        <AngleSize
                :angleSize="angleSize"
                :angleDirectionStart="angleDirectionStart"
        ></AngleSize>
    </v-group>
</template>

<script>
    import { mapState, mapMutations, mapActions } from 'vuex';
    import AngleSize from "./AngleSize";

    export default {
        name: "Angle",

        components: {
            AngleSize
        },

        props: [
            'pointCenter',
            'angleDirectionStart',
            'angleSize',
            'hidden',
        ],

        computed: {
            ...mapState('editor', [
                'drawingState',
            ]),

            groupConfig() {
                let {x, y} = this.pointCenter;

                return {
                    x,
                    y,
                    rotation: this.angleDirectionStart,
                    opacity: this.opacity,
                }
            },

            arcConfig() {
                return {
                    x: 0,
                    y: 0,
                    innerRadius: 0,
                    outerRadius: 36,
                    angle: this.angleSize,
                    fill: '#afcdee',
                    stroke: '#999',
                    strokeWidth: 1,
                    opacity: 0.85,
                }
            },

            isHovered() {
                return this.pointCenter['isAngleHover'];
            },

            opacity() {
                let hovered = !this.drawingState && this.isHovered;

                // display as hovered
                if (hovered) return 0.7;

                // don't display
                if (this.hidden || +this.angleSize === 90 || +this.angleSize === 180) return 0;

                // display as usual
                return 1;
            },

        },

        methods: {
            ...mapMutations('angles', [
                'setAngleIsHover',
            ]),

            ...mapActions('editPopup', [
                'openAngleEditPopup',
            ]),

            openEditPopup() {
                let angleData = {
                    pointCenter: this.pointCenter,
                    angleSize: this.angleSize
                };

                this.openAngleEditPopup(angleData);
            },

            hover(isHover) {
                this.setAngleIsHover({ point: this.pointCenter, isHover });
            },

        },

    }
</script>

<style scoped>

</style>